import { getRaceFromCareer, getRaceSpecialSkills } from "enefel/race";
import React from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import SpecialSkills from "../Skill/SpecialSkills";
import Group from "./Group";

const Wrapper = styled.div`
  display: inline-flex;
  gap: 0.3em;
  align-items: center;
  align-self: center;
`;

const Name = styled.div`
  white-space: nowrap;
`;

type RaceProps = {
  careerId: string;
  raceId?: string;
  withGroup?: boolean;
  showSpecialSkills?: boolean;
};

const Race: React.FC<RaceProps> = React.memo(
  ({ careerId, raceId, withGroup = true, showSpecialSkills = false }) => {
    const { t } = useTranslation("race");

    let race: string | undefined;
    if (raceId) {
      race = raceId;
    } else {
      // Si careerId se termine par "-career", c'est un RACE, sinon c'est un CAREER_ID
      const careerFromCareerId = getRaceFromCareer(careerId as any);
      race =
        careerFromCareerId ||
        (careerId.endsWith("-career") ? careerId : undefined);
    }

    if (!race) {
      return null;
    }

    const raceSpecialSkills = showSpecialSkills
      ? getRaceSpecialSkills(race as any)
      : [];

    return (
      <Wrapper>
        {withGroup && <Group race={race} />}
        {showSpecialSkills && raceSpecialSkills.length > 0 && (
          <SpecialSkills skills={raceSpecialSkills} separator=" " />
        )}
        <Name>{t("race:" + race, "__" + race)}</Name>
      </Wrapper>
    );
  }
);

export default Race;
